export const changeFileName = (file, filename) => {
  try {
    if (file) {
      const fileNameParts = file.name.split(".");
      const fileExtension = fileNameParts.pop(); // Get the extension

      //
      const newFileName = `${filename}.${fileExtension}`;

      //create new File
      const newFile = new File([file], newFileName, { type: file.type });
      return newFile;
    } else {
      return null;
    }
  } catch (error) {
    throw error;
  }
};
